'use client';
import React from 'react';
import Link from 'next/link';

interface SiteHeaderProps {
  variant?: 'default' | 'dark';
}

export default function SiteHeader({ variant = 'default' }: SiteHeaderProps) {
  if (variant === 'dark') {
    return (
      <header style={{
        position: 'sticky',
        top: 0,
        zIndex: 20,
        backdropFilter: 'blur(12px)',
        background: 'rgba(255,255,255,.72)',
        borderBottom: '1px solid rgba(18,32,51,.06)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '14px 22px',
      }}>
        <div style={{ fontWeight: 800, fontSize: '1.2rem' }}>
          <Link href="/" style={{ textDecoration: 'none', color: '#122033' }}>PRINTER SETUP</Link>
        </div>
        <Link
          href="/contact"
          style={{
            color: '#122033',
            textDecoration: 'none',
            fontWeight: 700,
            padding: '10px 16px',
            borderRadius: '12px',
            border: '1px solid rgba(18,32,51,.08)',
            background: '#fff',
          }}
        >
          Contact Us
        </Link>
      </header>
    );
  }

  return (
    <header style={{
      position: 'sticky',
      top: 0,
      zIndex: 20,
      backdropFilter: 'blur(12px)',
      background: 'rgba(255,255,255,.72)',
      borderBottom: '1px solid rgba(18,32,51,.06)',
    }}>
      <div style={{
        width: 'min(1180px, calc(100% - 32px))',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 0',
      }}>
        <Link href="/" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          fontWeight: 900,
          fontSize: '1.35rem',
          letterSpacing: '.2px',
          textDecoration: 'none',
          color: '#122033',
        }}>
          <span style={{
            width: '46px',
            height: '46px',
            borderRadius: '14px',
            background: 'linear-gradient(135deg, #0f8e8e, #13b3cf)',
            display: 'grid',
            placeItems: 'center',
            boxShadow: '0 10px 25px rgba(19,179,207,.22)',
            flexShrink: 0,
          }}>
            <svg viewBox="0 0 24 24" fill="none" width="24" height="24">
              <path d="M7 8V4h10v4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <rect x="4" y="8" width="16" height="8" rx="2.5" fill="white" fillOpacity=".18" stroke="white" strokeWidth="2" />
              <path d="M7 14h10v6H7z" fill="white" />
              <circle cx="17.2" cy="11.9" r="1" fill="white" />
            </svg>
          </span>
          <span>Printer Setup Online</span>
        </Link>

        <Link href="/contact" style={{
          fontWeight: 700,
          padding: '12px 18px',
          borderRadius: '14px',
          border: '1px solid rgba(18,32,51,.08)',
          background: '#fff',
          transition: '.25s ease',
          textDecoration: 'none',
          color: '#122033',
        }}>
          Contact Us
        </Link>
      </div>
    </header>
  );
}
